function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00ce7c;}.cls-2{fill:#ffc844;}.cls-3{fill:#ff8189;}.cls-4{fill:#7e57c5;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M99.98,0h-33.74c0,36.52-29.71,66.24-66.23,66.24v33.74C55.13,99.98,99.98,55.13,99.98,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M149.49,170.88c-11.68-42.83,6.41-89.91,46.64-113.03l16.82,29.25c-31.68,18.21-42.69,58.82-24.43,90.44l-29.26,16.81c-4.33-7.55-7.58-15.44-9.77-23.48Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M84.38,121.57c-2.28-44.34,25.43-86.47,69.67-100.48l10.2,32.17c-34.84,11.03-54.25,48.36-43.16,83.15l-32.18,10.18c-2.62-8.3-4.11-16.7-4.54-25.02Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M16.27,153.27c22.1,38.51,68.21,58.92,112.98,46.75l-8.84-32.57c-35.26,9.59-71.8-11.28-81.31-46.53l-32.56,8.86c2.29,8.4,5.59,16.27,9.74,23.49Z"
})));

var SvgDigioIconPositive = function SvgDigioIconPositive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    viewBox: "0 0 212.95 203.53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDigioIconPositive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/digio_icon_positive.99dcd61e.svg";
export { ForwardRef as ReactComponent };